module.exports = __webpack_public_path__ + "assets/img/jcb.bcb922cb.svg";